import React from 'react';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';
import { connect, useDispatch } from 'react-redux';

import Icons from 'consts/icons';
import { addAlert } from 'store/actions/alert/alerts';
import {
  AddPeriodicForm,
  AddTemporaryActivationModal,
} from 'components/zones/private/components';
import { authDelRequestWithParam, authPostRequest } from 'helpers/apiRequests';

import { checkDataRanges } from 'components/zones/utils/zoneDetailsUtils';
import { editLocalZone } from 'store/actions/map/allZones';
import ButtonsUseStyles from 'consts/styles/Buttons';
import { formStyles } from 'consts/styles/Form';
import DisplayActivations from 'components/zones/ActivationsDisplay';

const AddActivationForm = props => {
  const { language, setActiveStep, activeStep, createdZone } = props;
  const [days, setDays] = React.useState([]);
  const [hours, setHours] = React.useState([]);
  const [pickedHours, setPickedHours] = React.useState([]);
  const [weekdays, setWeekdays] = React.useState({});
  const [start, setStart] = React.useState(null);
  const [stop, setStop] = React.useState(null);
  const [activationType, setActivationType] = React.useState(null);
  const [addActivationFlag, setAddActivationFlag] = React.useState(false);
  const [invalidRecords, setInvalidRecords] = React.useState([]);

  const formClasses = formStyles();
  const classesButtons = ButtonsUseStyles();

  const dispatch = useDispatch();

  const handleDeletion = createdActivationUid => {
    const zoneWithDeletedActivation = {
      ...createdZone,
      activations: createdZone.activations.filter(
        activationObject => activationObject.uid !== createdActivationUid
      ),
    };

    dispatch(editLocalZone(zoneWithDeletedActivation));
  };

  const addActivation = async requestData => {
    const objectToSend = {
      ...requestData,
      zone: createdZone.uid,
    };
    const result = await authPostRequest('activations', objectToSend);
    if (result.status === 200) {
      dispatch(
        addAlert({
          title: language.alerts.addDataSuccess.title_,
          desc: language.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleAddActivationToZone(result.data[0]);
    } else
      dispatch(
        addAlert({
          title: language.alerts.dataProccessError.title_,
          desc: language.alerts.dataProccessError.desc_,
          type: 'error',
        })
      );
  };

  const handleAddActivationToZone = activation => {
    addActivationToZone(activation);
    moveForwardStep(activation);
  };

  const addActivationToZone = activation => {
    dispatch(
      editLocalZone({
        ...createdZone,
        activations: [...createdZone.activations, activation],
      })
    );
  };

  const moveForwardStep = activation => {
    if (!activation || activation.type !== 'temporary')
      setActiveStep(
        createdZone.type !== 'DRAP' ? activeStep + 1 : activeStep + 2
      );
  };

  const deleteActivationRequest = async activation => {
    const result = await authDelRequestWithParam('activations', activation.uid);
    if (result.status === 204) {
      dispatch(
        addAlert({
          title: language.alerts.addDataSuccess.title_,
          desc: language.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleDeletion(activation.uid);
    } else
      dispatch(
        addAlert({
          title: language.alerts[result.data.code].title_,
          desc: language.alerts[result.data.code].desc_,
          type: 'error',
        })
      );
  };

  React.useEffect(() => {
    const localweekDays = {};
    Object.values(language.weekDays).forEach((eachDay, index) => {
      localweekDays[eachDay] = index + 1;
    });
    setWeekdays(localweekDays);
    setHours([...Array(24).keys()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetAll = () => {
    setStop(null);
    setStart(null);
    setDays([]);
    setPickedHours([]);
  };

  const toggleWeekdays = day => {
    const newDaysArr = [...days];
    const indexOfElement = newDaysArr.indexOf(weekdays[day]);
    if (indexOfElement === -1) {
      newDaysArr.push(weekdays[day]);
    } else {
      newDaysArr.splice(indexOfElement, 1);
    }
    setDays(newDaysArr);
  };

  const toggleHours = hour => {
    const newHoursArr = [...pickedHours];
    const indexOfElement = newHoursArr.indexOf(hour);
    if (indexOfElement === -1) {
      newHoursArr.push(hour);
    } else {
      newHoursArr.splice(indexOfElement, 1);
    }
    setPickedHours(newHoursArr);
  };

  const handleChangeType = event => {
    resetAll();
    setActivationType(event.target.value);
  };

  const handleBackButton = () => {
    setAddActivationFlag(false);
    setStop(null);
    setStart(null);
  };

  const handleButtonClick = () => {
    /* Function firstly checks if the variable activationType is set (if not clicking the button causes skipping adding any activation), 
    if it is present there is another check if the type is temporary then the function checkDataRanges checks if the temporary
    time periods are overlaying, if yes those records are set to background color red and we do not proceed further */
    if (activationType) {
      const newActivationObject = {
        type: activationType,
        start: start ? new Date(start).getTime() : null,
        stop: stop ? new Date(stop).getTime() : null,
        days: days.length ? days : null,
        hours: pickedHours.length ? pickedHours : null,
      };
      if (activationType === 'temporary') {
        const isObjectValid = checkDataRanges(
          createdZone.activations,
          newActivationObject
        );
        setInvalidRecords(isObjectValid);
        if (isObjectValid.length) {
          return dispatch(
            addAlert({
              title: language.zonesDetails.addForm.activationForm.errorTitle_,
              desc: language.zonesDetails.addForm.activationForm.errorSubtitle_,
              type: 'error',
            })
          );
        }
      }
      addActivation(newActivationObject);
      handleBackButton();
    }
    moveForwardStep();
  };

  return (
    <Grid
      component="form"
      container
      spacing={2}
      className={`${formClasses.Form}__overflow-component ${formClasses.Form}--padding-left-right`}
    >
      <Container>
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
        >
          {language.zonesDetails.addForm.activationForm.chooseActivationType_}
        </Typography>
      </Container>
      <Container>
        <FormControl
          component="fieldset"
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex-between ${formClasses.Form}--width`}
        >
          <RadioGroup
            aria-label="activation"
            name="activation"
            value={activationType}
            color="primary"
            onChange={handleChangeType}
          >
            <Grid container>
              <Grid
                item
                xs={4}
                className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
              >
                <FormControlLabel
                  value="periodic"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={
                    language.zonesDetails.addForm.activationForm
                      .radioPeriodicLabel_
                  }
                />
              </Grid>
              <Grid
                item
                xs={4}
                className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
              >
                <FormControlLabel
                  value="temporary"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={
                    language.zonesDetails.addForm.activationForm
                      .radioTemporaryLabel_
                  }
                />
              </Grid>
              <Grid
                item
                xs={4}
                className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
              >
                <FormControlLabel
                  value="permanent"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={
                    language.zonesDetails.addForm.activationForm
                      .radioPermanentLabel_
                  }
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Container>
      <Container
        className={`${formClasses.Form}__overflow-component ${formClasses.Form}__overflow-component--small ${formClasses.Form}--padding-left-right`}
      >
        {activationType === 'periodic' && (
          <AddPeriodicForm
            days={days}
            hours={hours}
            language={language}
            pickedHours={pickedHours}
            toggleHours={toggleHours}
            toggleWeekdays={toggleWeekdays}
            weekdays={weekdays}
          />
        )}
        {activationType === 'temporary' && (
          <>
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            >
              {language.zonesDetails.addForm.activationForm.temporaryInfo_}
            </Typography>

            <>
              {/* render if variable stop is set, because permanent rules have start values */}
              {!!createdZone.activations[0]?.stop && (
                <DisplayActivations
                  activations={createdZone.activations}
                  remove={deleteActivationRequest}
                />
              )}
            </>

            <AddTemporaryActivationModal
              setStart={setStart}
              setStop={setStop}
              start={start}
              stop={stop}
              addActivation={handleButtonClick}
              activationType={activationType}
              handleBackButton={handleBackButton}
            />
          </>
        )}
        {activationType === 'permanent' && (
          <Typography
            variant="h3"
            className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
          >
            {language.zonesDetails.addForm.activationForm.permanentInfo_}
          </Typography>
        )}
      </Container>
      <Container>
        <div
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--flex-end ${formClasses.Form}--width`}
        >
          {activationType === 'temporary' ? (
            <Button
              className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
              onClick={
                () =>
                  setActiveStep(
                    createdZone.type !== 'DRAP'
                      ? activeStep + 1
                      : activeStep + 2
                  )
                // eslint-disable-next-line react/jsx-curly-newline
              }
              startIcon={<Icons.Actions.Skip />}
            >
              {!createdZone.activations.length
                ? language.zonesDetails.addForm.activationForm.skipButton_
                : language.zonesDetails.addForm.activationForm.further_}
            </Button>
          ) : (
            <Button
              onClick={() => handleButtonClick()}
              className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
              startIcon={
                activationType ? (
                  <Icons.Actions.Save2 />
                ) : (
                  <Icons.Actions.Skip />
                )
              }
            >
              {activationType
                ? language.zonesDetails.addForm.activationForm.saveButton_
                : language.zonesDetails.addForm.activationForm.skipButton_}
            </Button>
          )}
        </div>
      </Container>
    </Grid>
  );
};

AddActivationForm.propTypes = {
  language: PropTypes.object.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  createdZone: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(AddActivationForm);
